<template>
  <v-card flat class="input-card pa-4" color="rgba(44, 44, 46, 0.7)">
    <div class="section-title mb-3 white--text">Notiz zum Durchgang</div>
    <v-textarea v-model="note" label="Beobachtungen, Schwierigkeit etc. (optional)" rows="3" outlined dense hide-details class="mb-4"></v-textarea>
    <v-btn color="primary" block large class="add-set-btn" @click="submit">
      <v-icon left>mdi-check</v-icon>
      Durchgang speichern
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: "SensoProInput",
  data() {
    return {
      note: "",
    }
  },
  methods: {
    submit() {
      // Wir speichern die Notiz als einzigen Wert für diesen "Satz"
      this.$emit("add-set", [{ text: "note", value: this.note || "Durchgang absolviert" }])
      this.note = "" // Feld zurücksetzen
    },
  },
}
</script>

<style scoped>
.input-card {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px !important;
}
.section-title {
  font-weight: 500;
}
</style>
